import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'

import UserListItem from '../UserListItem/UserListItem.vue'
import TreeList from '../TreeList/TreeList.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

import * as types from '@recipient/store/types'
import * as typesGlobal from '@/store/types'


@Component({
	components: {
		TreeList,
		UserListItem,
	},
	computed: {
		...mapGetters({
			departments: types.RECIPIENT_DEPT_LIST,
//			companies: types.RECIPIENT_COMPPANIES_LIST
		}),
	},
	methods: {
		...mapActions({
			// intialize: types.RECIPIENT_INIT,
			loadUsers: types.RECIPIENT_USER_LIST
		}),
		...mapMutations({
			toggleDeptSelection: types.RECIPIENT_DEPT_TOGGLE,
		}),
	},
})
export default class OrgChartTree extends Vue {
	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: G E T T E R S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	departments!: recipient.Department[]

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: A C T I O N S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	// intialize!: () => void
	loadUsers!: (payload: recipient.DepartmentOption) => Promise<recipient.Department[]>
	toggleDeptSelection!: (payload: recipient.Department) => void
//	companies!: recipient.Company[];
	//
	// ────────────────────────────────────────────────────────── I ──────────
	//   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────────
	//

	async created() {
		// await this.intialize()
		
	}

	//
	// ────────────────────────────────────────────────────── I ──────────
	//   :::::: M E T H O D S : :  :   :    :     :        :          :
	// ────────────────────────────────────────────────────────────────
	//

	expandDepartment(dept: recipient.Department) {
		if (!dept.users || dept.users?.length === 0) {
			this.loadUsers(dept)
		}
	}
}
